import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "@farcaster/auth-kit/styles.css";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);
